<template>
  <div>
    <!-- Start: Content -->
    <section class="reservation-info" v-if="!isLoading">
      <div class="container">
        <div class="row">
          <!-- Start: Form Contact -->
          <div class="col-sm-6 col-sm-offset-1">
            <div id="form-contact">
              <div class="summary-error" v-if="$v.reservationRequest.$error">
                This form has errors
              </div>
              <form @submit.prevent="validateDoubleBook">
                <!-- Start: Booker -->
                <div>
                  <header>
                    Booker information
                    <span class="--blue"
                      >Please fill all information below.</span
                    >
                  </header>
                  <div class="row">
                    <div class="col-sm-12">
                      <div v-if="useCompanySelection" class="form-group">
                        <label class="required">Company</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.reservationRequest.booker.companyId.$error,
                          }"
                          placeholder=""
                          label="name"
                          v-model="reservationRequest.booker.companyId"
                          :options="companies"
                          :clearable="true"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.id"
                          @input="getBookersByCompanyId"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="
                            isSubmitted &&
                            !$v.reservationRequest.booker.companyId.required
                          "
                        >
                          Company is required
                        </small>
                      </div>
                      <div v-if="useCustomerSelection" class="form-group">
                        <label class="required">Customer</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.reservationRequest.booker.customerId.$error,
                          }"
                          placeholder=""
                          label="label"
                          v-model="reservationRequest.booker.customerId"
                          :options="customersAsBooker"
                          :clearable="true"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.id"
                          @input="onChangeBooker"
                          :disabled="!reservationRequest.booker.companyId"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="
                            isSubmitted &&
                            !$v.reservationRequest.booker.customerId.required
                          "
                        >
                          Customer is required
                        </small>
                      </div>
                      <template
                        v-if="
                          reservationRequest.booker.customerId &&
                          isUseFreetext(reservationRequest.booker.customerId)
                        "
                      >
                        <div class="form-group">
                          <label class="required">Select Title</label>
                          <div
                            class="btn-group btn-group-toggle"
                            data-toggle="buttons"
                          >
                            <label
                              class="btn"
                              :class="{
                                active:
                                  reservationRequest.booker.freetext.title ===
                                  item.value,
                              }"
                              v-for="(item, index) in personTitles"
                              :key="index"
                              @click="
                                reservationRequest.booker.freetext.title =
                                  item.value
                              "
                            >
                              <input
                                type="radio"
                                name="booker_title"
                                autocomplete="off"
                                :value="item.value"
                                :checked="
                                  reservationRequest.booker.freetext.title ===
                                  item.value
                                "
                                v-model="
                                  reservationRequest.booker.freetext.title
                                "
                              />
                              {{ item.text }}
                            </label>
                          </div>
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.booker.freetext.title
                                .required
                            "
                            style="display: block"
                          >
                            Title is required
                          </small>
                        </div>
                        <div class="form-group">
                          <label class="required">Full Name</label>
                          <input
                            type="text"
                            class="form-control alphabets-only"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                !$v.reservationRequest.booker.freetext.fullName
                                  .required,
                            }"
                            v-model="
                              reservationRequest.booker.freetext.fullName
                            "
                            maxlength="150"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.booker.freetext.fullName
                                .required
                            "
                            style="display: block"
                          >
                            Fullname is required
                          </small>
                        </div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label class="required">Phone</label>
                              <v-select
                                class="v-search-select"
                                placeholder=""
                                label="label"
                                v-model="
                                  reservationRequest.booker.freetext.phoneCode
                                "
                                :options="phoneCodes"
                                :clearable="false"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.dial"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    !$v.reservationRequest.booker.freetext
                                      .phoneCode.required,
                                }"
                              >
                                <template #search="{ attributes, events }">
                                  <input
                                    class="vs__search"
                                    name="booker_phoneCode"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                                <template slot="option" slot-scope="option">
                                  <div class="phone-wrapper">
                                    <div
                                      class="phone-icon"
                                      :class="option.icon"
                                    ></div>
                                    <div class="phone-text">
                                      {{ option.iata }}
                                    </div>
                                  </div>
                                </template>
                              </v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.reservationRequest.booker.freetext
                                    .phoneCode.required
                                "
                                style="display: block"
                              >
                                Phone code is required
                              </small>
                            </div>
                          </div>
                          <div
                            class="col-sm-8"
                            style="padding-left: 0; padding-top: 30px"
                          >
                            <div class="form-group">
                              <input
                                type="text"
                                class="form-control numbers-only"
                                name="booker_phoneNumber"
                                v-model="
                                  reservationRequest.booker.freetext.phoneNumber
                                "
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    !$v.reservationRequest.booker.freetext
                                      .phoneNumber.required,
                                }"
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.reservationRequest.booker.freetext
                                    .phoneNumber.required
                                "
                                style="display: block"
                              >
                                Phone number is required
                              </small>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">Email</label>
                          <input
                            class="form-control"
                            placeholder="e.g youremail@gmail.com"
                            v-model="reservationRequest.booker.freetext.email"
                            maxlength="100"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                !$v.reservationRequest.booker.freetext.email
                                  .required,
                            }"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.booker.freetext.email
                                .required
                            "
                            style="display: block"
                          >
                            Email is required
                          </small>
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              $v.reservationRequest.booker.freetext.email
                                .required &&
                              !$v.reservationRequest.booker.freetext.email.email
                            "
                            style="display: block"
                          >
                            Email is invalid
                          </small>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <!-- End: Booker -->

                <!-- Start: Passenger -->
                <div class="passenger-information">
                  <label class="cursor-pointer">
                    <input
                      type="checkbox"
                      class="control-checkbox"
                      v-model="isPassengerSameAsBooker"
                      @change="copyBooker()"
                    />
                    <span
                      class="pl-5 font-weight-normal v-align-middle text-filter"
                    >
                      Same as Booking Contact Information
                    </span>
                  </label>
                  <header>
                    Passenger information
                    <span>Please fill all information below.</span>
                  </header>
                  <div class="row">
                    <div class="col-sm-12">
                      <div v-if="useCompanySelection" class="form-group">
                        <label class="required">Company</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.reservationRequest.passengers.$each[0]
                                .companyId.$error,
                          }"
                          placeholder=""
                          label="name"
                          v-model="reservationRequest.passengers[0].companyId"
                          :options="companies"
                          :clearable="true"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.id"
                          :disabled="isPassengerSameAsBooker"
                          @input="getPassengersByCompanyId"
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="
                            isSubmitted &&
                            !$v.reservationRequest.passengers.$each[0].companyId
                              .required
                          "
                        >
                          Company is required
                        </small>
                      </div>
                      <div v-if="useCustomerSelection" class="form-group">
                        <label class="required">Customer</label>
                        <v-select
                          class="v-search-select"
                          :class="{
                            'field-error':
                              isSubmitted &&
                              $v.reservationRequest.passengers.$each[0]
                                .customerId.$error,
                          }"
                          placeholder=""
                          label="label"
                          v-model="reservationRequest.passengers[0].customerId"
                          :options="customersAsPassenger"
                          :clearable="true"
                          :searchable="true"
                          :filterable="true"
                          :reduce="(option) => option.id"
                          :disabled="
                            isPassengerSameAsBooker ||
                            !reservationRequest.passengers[0].companyId
                          "
                        />
                        <small
                          class="form-text sts-danger"
                          v-if="
                            isSubmitted &&
                            !$v.reservationRequest.passengers.$each[0]
                              .customerId.required
                          "
                        >
                          Customer is required
                        </small>
                      </div>
                      <template
                        v-if="
                          reservationRequest.passengers[0].customerId &&
                          isUseFreetext(
                            reservationRequest.passengers[0].customerId
                          )
                        "
                      >
                        <div class="form-group">
                          <label class="required">Select Title</label>
                          <div
                            class="btn-group btn-group-toggle"
                            data-toggle="buttons"
                          >
                            <label
                              class="btn"
                              :class="{
                                active:
                                  reservationRequest.passengers[0].title ===
                                  item.value,
                              }"
                              v-for="(item, index) in personTitles"
                              :key="index"
                              @click="
                                reservationRequest.passengers[0].title =
                                  item.value
                              "
                              :disabled="isPassengerSameAsBooker"
                            >
                              <input
                                type="radio"
                                name="booker_title"
                                autocomplete="off"
                                :value="item.value"
                                :checked="
                                  reservationRequest.passengers[0].title ===
                                  item.value
                                "
                                v-model="reservationRequest.passengers[0].title"
                                :disabled="isPassengerSameAsBooker"
                              />
                              {{ item.text }}
                            </label>
                          </div>
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.passengers.$each[0].title
                                .required
                            "
                            style="display: block"
                          >
                            Title is required
                          </small>
                        </div>
                        <div class="form-group">
                          <label class="required">Full Name</label>
                          <input
                            type="text"
                            class="form-control alphabets-only"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                !$v.reservationRequest.passengers.$each[0]
                                  .fullName.required,
                            }"
                            v-model="reservationRequest.passengers[0].fullName"
                            maxlength="150"
                            :disabled="isPassengerSameAsBooker"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.passengers.$each[0]
                                .fullName.required
                            "
                            style="display: block"
                          >
                            Fullname is required
                          </small>
                        </div>
                        <div class="row">
                          <div class="col-sm-4">
                            <div class="form-group">
                              <label class="required">Phone</label>
                              <v-select
                                class="v-search-select"
                                placeholder=""
                                label="label"
                                v-model="
                                  reservationRequest.passengers[0].phoneCode
                                "
                                :options="phoneCodes"
                                :clearable="false"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.dial"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    !$v.reservationRequest.passengers.$each[0]
                                      .phoneCode.required,
                                }"
                                :disabled="isPassengerSameAsBooker"
                              >
                                <template #search="{ attributes, events }">
                                  <input
                                    class="vs__search"
                                    name="booker_phoneCode"
                                    v-bind="attributes"
                                    v-on="events"
                                  />
                                </template>
                                <template slot="option" slot-scope="option">
                                  <div class="phone-wrapper">
                                    <div
                                      class="phone-icon"
                                      :class="option.icon"
                                    ></div>
                                    <div class="phone-text">
                                      {{ option.iata }}
                                    </div>
                                  </div>
                                </template>
                              </v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.reservationRequest.passengers.$each[0]
                                    .phoneCode.required
                                "
                                style="display: block"
                              >
                                Phone code is required
                              </small>
                            </div>
                          </div>
                          <div
                            class="col-sm-8"
                            style="padding-left: 0; padding-top: 30px"
                          >
                            <div class="form-group">
                              <input
                                type="text"
                                class="form-control numbers-only"
                                name="booker_phoneNumber"
                                v-model="
                                  reservationRequest.passengers[0].phoneNumber
                                "
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    !$v.reservationRequest.passengers.$each[0]
                                      .phoneNumber.required,
                                }"
                                :disabled="isPassengerSameAsBooker"
                              />
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.reservationRequest.passengers.$each[0]
                                    .phoneNumber.required
                                "
                                style="display: block"
                              >
                                Phone number is required
                              </small>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">Email</label>
                          <input
                            class="form-control"
                            placeholder="e.g youremail@gmail.com"
                            v-model="reservationRequest.passengers[0].email"
                            maxlength="100"
                            :class="{
                              'field-error':
                                isSubmitted &&
                                !$v.reservationRequest.passengers.$each[0].email
                                  .required,
                            }"
                            :disabled="isPassengerSameAsBooker"
                          />
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              !$v.reservationRequest.passengers.$each[0].email
                                .required
                            "
                            style="display: block"
                          >
                            Email is required
                          </small>
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted &&
                              $v.reservationRequest.passengers.$each[0].email
                                .required &&
                              !$v.reservationRequest.passengers.$each[0].email
                                .email
                            "
                            style="display: block"
                          >
                            Email is invalid
                          </small>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <!-- End: Passenger -->

                <!-- Start: Ancillary -->
                <div
                  class="box-addons"
                  v-if="hasAncillary"
                  style="padding-top: 20px"
                >
                  <div class="panel-group" id="accordion">
                    <div class="panel panel-default">
                      <div class="panel-heading">
                        <h4 class="panel-title">
                          <a
                            data-toggle="collapse"
                            data-parent="#accordion"
                            href="#collapse1"
                          >
                            + Extras
                          </a>
                        </h4>
                      </div>
                      <div id="collapse1" class="panel-collapse collapse">
                        <div class="panel-body">
                          <div class="table-p10">
                            <div class="table-responsive">
                              <table class="table table-hover mtz">
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>Item Name</th>
                                    <th>Price</th>
                                    <th
                                      class="text-center"
                                      style="width: 125px"
                                    >
                                      Qty
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(item, index) in ancillaries"
                                    :key="item.masterClassAncillaryId"
                                  >
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>
                                      {{ item.currencyCode }}
                                      {{ printMoney(item.rate) }}
                                    </td>
                                    <td class="text-center">
                                      <input
                                        class="form-control numbers-only"
                                        type="number"
                                        v-model="item.quantity"
                                        @change="onChangeAncillary(item)"
                                        @keyup="onChangeAncillary(item)"
                                        @blur="onBlurAncillary(item)"
                                        min="0"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End: Ancillary -->

                <!-- Start: Airport Transfer Pick-up Details -->
                <div class="passenger-information" v-if="isAirportTransfer">
                  <header>
                    Pick-up Details
                    <span>Please fill all information below.</span>
                  </header>
                  <div class="row">
                    <div class="col-sm-12">
                      <!-- Start: Flight Information -->
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group">
                            <label class="required">Airline</label>
                            <v-select
                              class="v-search-select"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  $v.reservationRequest.departureAirline.$error,
                              }"
                              placeholder="Select an airline"
                              label="label"
                              v-model="reservationRequest.departureAirline"
                              :options="orderedAirlines"
                              :clearable="true"
                              :searchable="true"
                              :filterable="true"
                              :reduce="(option) => option.iataCode"
                            ></v-select>
                            <small
                              class="form-text sts-danger"
                              v-if="
                                isSubmitted &&
                                !$v.reservationRequest.departureAirline.required
                              "
                              >Airline is required</small
                            >
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label class="required">Flight/Tail No.</label>
                            <input
                              class="form-control alphabets-numbers-only"
                              :class="{
                                'field-error':
                                  isSubmitted &&
                                  $v.reservationRequest.departureFlightNumber
                                    .$error,
                              }"
                              type="text"
                              name="departure_flightNumber"
                              autocomplete="off"
                              v-model="reservationRequest.departureFlightNumber"
                            />
                            <div
                              v-if="
                                isSubmitted &&
                                $v.reservationRequest.departureFlightNumber
                                  .$error
                              "
                            >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  !$v.reservationRequest.departureFlightNumber
                                    .required
                                "
                                >Flight Number is invalid</small
                              >
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  !$v.reservationRequest.departureFlightNumber
                                    .maxLength
                                "
                                >Flight Number must be less than
                                {{
                                  $v.reservationRequest.departureFlightNumber
                                    .$params.maxLength.max
                                }}
                                characters</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- End: Flight Information -->
                      <!-- Start: Notes to Driver -->
                      <div class="form-group">
                        <label for>Notes to Driver</label>
                        <textarea
                          class="form-control"
                          rows="5"
                          name="notes"
                          v-model="reservationRequest.notes"
                        ></textarea>
                        <div class="text-right word-count">
                          {{ reservationRequest.notes.length }} &#47; 400
                          characters
                        </div>
                        <small
                          class="form-text sts-danger"
                          v-if="
                            isSubmitted &&
                            !$v.reservationRequest.notes.maxLength
                          "
                          >Notes must be less than
                          {{
                            $v.reservationRequest.notes.$params.maxLength.max
                          }}
                          characters</small
                        >
                      </div>
                      <!-- End: Notes to Driver -->
                    </div>
                  </div>
                </div>
                <!-- End: Airport Transfer Pick-up Details -->

                <button type="submit" class="btn btn-primary mt-20">
                  Proceed to Payment
                </button>
              </form>
            </div>
          </div>
          <!-- End: Form Contact -->

          <!-- Start: Right Panel -->
          <div class="col-sm-5 postick">
            <div class="price-detail-header">
              <div class="grand-total">
                <table class="table table-amount mt-5">
                  <thead>
                    <tr>
                      <th class="text-left --green">Amount to Pay</th>
                      <th class="text-right">
                        {{ vehicle.currencyCode }} {{ printMoney(grandTotal) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left">Base</td>
                      <td class="text-right">
                        {{ printMoney(vehicle.baseFare) }}
                      </td>
                    </tr>
                    <tr v-if="isSelfDrive">
                      <td class="text-left">Insurance</td>
                      <td class="text-right">
                        {{ printMoney(totalInsurance) }}
                      </td>
                    </tr>
                    <tr v-if="isSelfDrive">
                      <td colspan="2">
                        <ul class="table-list">
                          <li
                            v-for="insurance in vehicle.selfDriveRate.items"
                            :key="insurance.code"
                          >
                            {{ insurance.name }} ({{ insurance.code }})
                            <span class="value">
                              {{ printMoney(insurance.rate) }}
                            </span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr v-if="hasSurcharge">
                      <td class="text-left">Surcharge</td>
                      <td class="text-right">
                        {{ printMoney(vehicle.surcharge) }}
                      </td>
                    </tr>
                    <tr v-if="isAncillarySelected">
                      <td class="text-left">Ancillary</td>
                      <td class="text-right">
                        {{ printMoney(totalAncillary) }}
                      </td>
                    </tr>
                    <tr v-if="isAncillarySelected">
                      <td colspan="2">
                        <ul class="table-list">
                          <li
                            v-for="(ancillary, index) in selectedAncillaries"
                            :key="index"
                          >
                            {{ ancillary.name
                            }}<span>x{{ ancillary.quantity }}</span
                            ><span class="value">{{
                              printMoney(ancillary.subtotal)
                            }}</span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="reservation-summary--small">
              <div class="dropandpickup cRow">
                <div class="col-sm-6 plz">
                  <div class="location-pick-up">
                    {{ searchParameterPickUpLocation }}
                  </div>
                  <div class="row mt-10">
                    <div class="col-sm-5 prz">
                      <div class="rent-date">{{ shortPickUpDate }}</div>
                    </div>
                    <div class="col-sm-7 text-right">
                      <div class="rent-time">
                        <i class="ic-time"></i>
                        {{ shortPickUpTime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 prz divider-left">
                  <div class="location-drop-off text-right">
                    {{ searchParameterDropOffLocation }}
                  </div>
                  <div class="row mt-10">
                    <div class="col-sm-5 prz">
                      <div class="rent-date">{{ shortDropOffDate }}</div>
                    </div>
                    <div class="col-sm-7 text-right">
                      <div class="rent-time">
                        <i class="ic-time"></i>
                        {{ shortDropOffTime }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="overlimit-info"
                v-if="searchParameter.serviceType === 'Rental'"
              >
                <div class="text-info">
                  <span class="info-icon mhide"></span>Returns more than one
                  hour will be charged an overtime fee.
                </div>
              </div>

              <div class="cRow">
                <template v-if="searchParameter.mode === 'OnDemand'">
                  <div class="col-sm-7">
                    <img :src="vehicle.imageUri" class="cars-image" alt />
                  </div>
                  <div class="col-sm-5">
                    <div class="provider-img">
                      <img :src="vehicle.providers[0].imageUri" alt />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="col-sm-12">
                    <img :src="vehicle.imageUri" class="cars-image" alt />
                  </div>
                </template>
              </div>

              <div class="row text-center">
                <div class="table-legend mt-15">
                  <ul>
                    <li v-if="isAirportTransfer">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-else><i class="ic-time"></i>Hourly Booking</li>
                  </ul>
                </div>

                <div>
                  <div v-if="hasVehicleName">
                    <span class="cars-brand">
                      {{ vehicle.factoryName }} {{ vehicle.brandName }}
                    </span>
                    or similar
                  </div>
                  <div class="type-car">{{ vehicle.className }} Class</div>
                  <div
                    class="type-car hidden"
                    :class="{
                      'self-drive': isSelfDrive,
                      'with-driver': !isSelfDrive,
                    }"
                  ></div>
                  <div
                    class="row"
                    v-if="
                      hasPaxCapacity ||
                      hasLargeBaggageCapacity ||
                      hasSmallBaggageCapacity
                    "
                  >
                    <div class="col-sm-12">
                      <div class="capacity-seat" v-if="hasPaxCapacity">
                        Max. Passenger {{ vehicle.feature.paxCapacity }}
                      </div>
                      <!-- <div class="capacity-large-baggage" v-if="hasLargeBaggageCapacity">
                        Large Bag. x{{ vehicle.feature.largeBaggageCapacity }}
                      </div>
                      <div class="capacity-baggage" v-if="hasSmallBaggageCapacity">
                        Small Bag. x{{ vehicle.feature.smallBaggageCapacity }}
                      </div> -->
                      <!-- <div
                        :class="{
                          'transmission-automatic': vehicle.transmission === 'Automatic',
                          'transmission-manual': vehicle.transmission === 'Manual',
                        }"
                      >
                        {{
                          vehicle.transmission === "Automatic"
                            ? "Automatic Transmission"
                            : "Manual Gearbox"
                        }}
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.row.text-center -->

              <div
                class="provider-box cRowen-col"
                v-if="searchParameter.mode === 'OnDemand'"
              >
                <div class="provider-name">{{ vehicle.providers[0].name }}</div>
                <!-- <button
                  class="btn btn-info"
                  data-toggle="modal"
                  data-target="#terms-modal"
                >
                  Rental Terms
                </button> -->
              </div>

              <div class="reservation-button">
                <button class="btn btn-block btn-nobg" @click="refresh()">
                  Change Car
                </button>
              </div>
            </div>
          </div>
          <!-- End: Right Panel -->
        </div>
      </div>
    </section>
    <!-- End: Content -->

    <!-- Start: Modal -->
    <!-- <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header" style="padding-bottom: 10px">
          <div class="pull-left" id="gmap-custom-control">
            <button type="button" class="btn btn-default remove-location">Reset</button>
            <button type="button" class="btn btn-primary save-location">Apply</button>
          </div>
          <div class="pull-right">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <i class="ic-close"></i>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <div class="gmap-wrapper">
              <div class="pac-card" id="pac-card">
                <div id="pac-container">
                  <input id="pac-input" type="text" placeholder="Enter a location" />
                </div>
              </div>
              <div id="map"></div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- End: Modal -->

    <!-- Start: Modal -->
    <!-- <div class="modal fade" role="dialog" id="terms-modal">
      <div class="modal-dialog modal-md">
        <div class="modal-header" style="padding-bottom: 10px">
          <div class="pull-left">
            <h4 class="--blue">
              <strong>Important Information!</strong>
            </h4>
          </div>
          <div class="pull-right">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <i class="ic-close"></i>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <div class="terms-body">
              <div class="terms-list">
                <div class="col-sm-5 plz">
                  <div class="icon-terms">
                    <i class="ic-personal"></i>
                  </div>
                  <h5>
                    Driving &amp; License
                    <span>Requirements</span>
                  </h5>
                </div>
                <div class="col-sm-7 prz">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga omnis
                    reiciendis exercitationem accusantium ipsum cum quae nihil voluptatum
                    libero aliquid nam deserunt, deleniti eius animi eos at, porro unde?
                    Aut.
                  </p>
                </div>
              </div>
              <div class="terms-list">
                <div class="col-sm-5 plz">
                  <div class="icon-terms">
                    <i class="ic-corporate-card"></i>
                  </div>
                  <h5>
                    Security Deposit
                    <span>US$ 35.00</span>
                  </h5>
                </div>
                <div class="col-sm-7 prz">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga omnis
                    reiciendis exercitationem accusantium ipsum cum quae nihil voluptatum
                    libero aliquid nam deserunt, deleniti eius animi eos at, porro unde?
                    Aut.
                  </p>
                </div>
              </div>
              <div class="terms-list">
                <div class="col-sm-5 plz">
                  <div class="icon-terms">
                    <i class="ic-car"></i>
                  </div>
                  <h5>
                    Damage Access
                    <span>US$ 35.00</span>
                  </h5>
                </div>
                <div class="col-sm-7 prz">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga omnis
                    reiciendis exercitationem accusantium ipsum cum quae nihil voluptatum
                    libero aliquid nam deserunt, deleniti eius animi eos at, porro unde?
                    Aut.
                  </p>
                </div>
              </div>
              <div class="terms-list">
                <div class="col-sm-5 plz">
                  <div class="icon-terms">
                    <i class="ic-manage-trip"></i>
                  </div>
                  <h5>
                    Mileage
                    <span>Unlimited</span>
                  </h5>
                </div>
                <div class="col-sm-7 prz">
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga omnis
                    reiciendis exercitationem accusantium ipsum cum quae nihil voluptatum
                    libero aliquid nam deserunt, deleniti eius animi eos at, porro unde?
                    Aut.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import numeral from "numeral";
import {
  required,
  minValue,
  maxValue,
  maxLength,
  email,
} from "vuelidate/lib/validators";
import _ from "lodash";
// import numeral from "numeral";
import instantAvailabilityService from "@/services/shop/availability/instantAvailabilityService.js";
import instantReservationService from "@/services/shop/reservation/instantReservationService.js";
import countryPhoneService from "@/services/master/countryPhoneService.js";
// import maverickMap from "@/plugins/google/map.js";
// import maverickGeocoding from "@/plugins/google/geocode.js";

export default {
  data() {
    return {
      reservationRequest: {
        correlationId: null,
        serviceType: null,
        vehicleId: null,
        providerId: null,
        departureAirline: null,
        departureFlightNumber: null,
        notes: "",
        booker: {
          companyId: null,
          customerId: null,
          freetext: {
            title: "Mr",
            fullName: null,
            email: null,
            phoneCode: null,
            phoneNumber: null,
          },
        },
        passengers: [
          {
            companyId: null,
            customerId: null,
            title: "Mr",
            fullName: null,
            email: null,
            phoneCode: null,
            phoneNumber: null,
          },
        ],
        ancillaries: [],
      },
      isSubmitted: false,
      isSelfDrive: false,
      isPassengerSameAsBooker: false,
      moneyFormat: null,
      vehicle: null,
      totalAncillary: 0,
      ancillaries: [],
      rentDays: null,
      items: [],
      airlines: [],
      selectedAncillaries: [],
      companies: [],
      customersAsBooker: [],
      customersAsPassenger: [],
      phoneCodes: [],
      isLoading: false,
      searchParameter: { mode: "" },
      personTitles: [
        { value: "Mr", text: "Mr" },
        { value: "Mrs", text: "Mrs" },
        { value: "Ms", text: "Ms" },
      ],
      msg: "Please wait",
      userProfile: {},
      useCompanySelection: true,
      useCustomerSelection: true,
    };
  },
  validations() {
    const v = {
      reservationRequest: {
        booker: {
          companyId: { required },
          customerId: { required },
        },
        passengers: {
          $each: {
            companyId: { required },
            customerId: { required },
          },
        },
        departureAirline: this.validationDepartureAirline,
        departureFlightNumber: this.validationDepartureFlightNumber,
        notes: { maxLength: maxLength(400) },
      },
    };

    if (this.isUseFreetext(this.reservationRequest.booker.customerId)) {
      v.reservationRequest.booker.freetext = {
        title: { required },
        fullName: { required },
        email: { required, email },
        phoneCode: { required },
        phoneNumber: { required },
      };
    }

    if (this.isUseFreetext(this.reservationRequest.passengers[0].customerId)) {
      v.reservationRequest.passengers.$each = {
        companyId: { required },
        customerId: { required },
        title: { required },
        fullName: { required },
        email: { required, email },
        phoneCode: { required },
        phoneNumber: { required },
      };
    }

    return v;
  },
  computed: {
    searchParameterPickUpLocation: function () {
      return this.searchParameter.pickUpLocation !== undefined
        ? this.searchParameter.pickUpLocation.name
        : "";
    },
    searchParameterDropOffLocation: function () {
      return this.searchParameter.dropOffLocation !== undefined &&
        this.searchParameter.dropOffLocation !== null
        ? this.searchParameter.dropOffLocation.name
        : "Same Location";
    },
    pickUpOtherLocationName: function () {
      return this.pickUpOtherLocation !== null
        ? this.pickUpOtherLocation.name
        : "";
    },
    dropOffOtherLocationName: function () {
      return this.dropOffOtherLocation !== null
        ? this.dropOffOtherLocation.name
        : "";
    },
    pickUpOtherLocationRate: function () {
      return this.pickUpOtherLocation !== null
        ? this.pickUpOtherLocation.rate
        : "Select Location by Map";
    },
    dropOffOtherLocationRate: function () {
      return this.dropOffOtherLocation !== null
        ? this.dropOffOtherLocation.rate
        : "Select Location by Map";
    },
    shortPickUpDate: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDate,
        "D MMM"
      );
    },
    shortPickUpTime: function () {
      return this.$helper.toDateString(
        this.searchParameter.pickUpDate,
        "HH:mm"
      );
    },
    shortDropOffDate: function () {
      return this.$helper.toDateString(
        this.searchParameter.dropOffDate,
        "D MMM"
      );
    },
    shortDropOffTime: function () {
      return this.$helper.toDateString(
        this.searchParameter.dropOffDate,
        "HH:mm"
      );
    },
    isAirportTransfer: function () {
      return (
        this.searchParameter &&
        this.searchParameter.serviceType &&
        this.searchParameter.serviceType === "AirportTransfer"
      );
    },
    hasAncillary: function () {
      return this.ancillaries && this.ancillaries.length > 0;
    },
    isAncillarySelected: function () {
      return this.hasAncillary && this.selectedAncillaries.length > 0;
    },
    hasSurcharge: function () {
      return this.vehicle && this.vehicle.surcharge > 0;
    },
    hasPaxCapacity: function () {
      return (
        this.vehicle.feature &&
        this.vehicle.feature.paxCapacity &&
        parseInt(this.vehicle.feature.paxCapacity) > 0
      );
    },
    hasLargeBaggageCapacity: function () {
      return (
        this.vehicle.feature &&
        this.vehicle.feature.largeBaggageCapacity &&
        parseInt(this.vehicle.feature.largeBaggageCapacity) > 0
      );
    },
    hasSmallBaggageCapacity: function () {
      return (
        this.vehicle.feature &&
        this.vehicle.feature.smallBaggageCapacity &&
        parseInt(this.vehicle.feature.smallBaggageCapacity) > 0
      );
    },
    hasVehicleName: function () {
      return (
        (this.vehicle.factoryName && this.factoryName !== "") ||
        (this.vehicle.brandName && this.vehicle.brandName !== "")
      );
    },
    totalInsurance: function () {
      let total = 0;
      if (
        this.isSelfDrive &&
        this.vehicle.selfDriveRate &&
        this.vehicle.selfDriveRate.items
      ) {
        total = this.vehicle.selfDriveRate.items.reduce((a, b) => {
          return a + b.rate;
        }, 0);
      }
      return total;
    },
    grandTotal: function () {
      let total = 0;
      if (this.vehicle) {
        total +=
          this.vehicle.baseFare + this.vehicle.surcharge + this.totalAncillary;
      }
      total += this.totalInsurance;
      return total;
    },
    orderedAirlines: function () {
      const airlines = _.orderBy(this.airlines, "iataCode");
      for (let index = 0; index < airlines.length; index++) {
        const airline = airlines[index];
        airline.label = `(${airline.iataCode}) ${airline.name}`;
      }
      return airlines;
    },
    validationDepartureAirline: function () {
      return this.isAirportTransfer ? { required } : {};
    },
    validationDepartureFlightNumber: function () {
      return this.isAirportTransfer
        ? { required, maxLength: maxLength(4) }
        : {};
    },
  },
  async created() {
    this.$helper.scrollTop();
    this.isLoading = true;
    await this.getBookingInfo();
    await this.getPhoneCodes();

    this.userProfile = await this.$store.dispatch("user/getProfile");
    this.setupForm();
  },
  mounted() {
    // if (!this.map) {
    //   // creates map instance
    //   this.map = new maverickMap({
    //     mapId: "map",
    //     lat: -6.17003832454938,
    //     lng: 106.81490242481232,
    //     marker: true,
    //     autocomplete: true,
    //     confirmLocationCallback: this.confirmLocation,
    //     removeLocationCallback: this.removeLocation,
    //     autoCompleteGetPlaceCallback: this.getPlace,
    //     markerChangeCallback: this.markerChange,
    //   });
    //   this.map.initialize();
    // }
    // if (!this.geocoder) {
    //   // creates geocoder instance
    //   this.geocoder = new maverickGeocoding();
    // }
  },
  updated() {
    this.$helper.alphabetsOnly();
    this.$helper.numbersOnly();
    this.$helper.alphabetsNumbersOnly();

    // setTimeout(() => {
    //   $("#RefreshConfirmation").modal({ backdrop: "static", keyboard: false });
    // }, this.$helper.fromMinutestoMilliseconds(30));
  },
  methods: {
    setupForm() {
      if (
        this.userProfile.selectors &&
        this.userProfile.selectors["Companies"]
      ) {
        const userCompany = this.companies.find(
          (company) =>
            company.id == this.userProfile.selectors["Companies"].defaultId
        );

        if (userCompany) {
          this.reservationRequest.booker.companyId = userCompany.id;
          this.getBookersByCompanyId(userCompany.id);

          const userCustomer = userCompany.customers.find(
            (cust) => cust.id == this.userProfile.id
          );

          if (userCustomer) {
            this.reservationRequest.booker.customerId = userCustomer.id;
          }
        }
      } else {
        this.useCompanySelection = false;
        this.useCustomerSelection = false;
        this.reservationRequest.booker.companyId = this.$helper.emptyGuid();
        this.reservationRequest.booker.customerId = this.$helper.emptyGuid();
        this.reservationRequest.passengers[0].companyId =
          this.$helper.emptyGuid();
        this.reservationRequest.passengers[0].customerId =
          this.$helper.emptyGuid();
      }
    },
    onChangeAncillary(ancillary) {
      this.totalAncillary = 0;
      this.selectedAncillaries = this.ancillaries.filter(
        (x) => x.quantity && parseInt(x.quantity) > 0
      );
      for (let i = 0; i < this.selectedAncillaries.length; i++) {
        const item = this.selectedAncillaries[i];
        item.subtotal = item.rate * parseInt(item.quantity);
        this.totalAncillary += item.subtotal;
      }
    },
    onBlurAncillary(item) {
      if (item.quantity === "") {
        item.quantity = 0;
      }
    },
    isUseFreetext(customerId) {
      return customerId === this.$helper.emptyGuid();
    },
    getBookersByCompanyId(companyId) {
      const freetextValue = {
        companyId: companyId,
        emails: [],
        fullName: "Free Text",
        label: "Free Text",
        gender: null,
        id: this.$helper.emptyGuid(),
        phones: [],
        title: null,
      };

      this.customersAsBooker = this.companies
        .flatMap((x) => x.customers)
        .filter((x) => x.companyId === companyId);

      this.customersAsBooker = this.$helper.prependToArray(
        freetextValue,
        this.customersAsBooker
      );

      this.reservationRequest.booker.customerId = null;
      this.reservationRequest.passengers[0].customerId = null;
      if (this.isPassengerSameAsBooker) {
        this.reservationRequest.passengers[0].companyId = companyId;
      } else {
        this.customersAsPassenger = [];
        this.reservationRequest.passengers[0].companyId = null;
      }
    },
    getPassengersByCompanyId(companyId) {
      const freetextValue = {
        companyId: companyId,
        emails: [],
        fullName: "Free Text",
        label: "Free Text",
        gender: null,
        id: this.$helper.emptyGuid(),
        phones: [],
        title: null,
      };

      this.customersAsPassenger = this.companies
        .flatMap((x) => x.customers)
        .filter((x) => x.companyId === companyId);

      this.customersAsPassenger = this.$helper.prependToArray(
        freetextValue,
        this.customersAsPassenger
      );

      this.reservationRequest.passengers[0].customerId = null;
    },
    onChangeBooker(item) {
      if (this.isPassengerSameAsBooker) {
        this.customersAsPassenger = this.customersAsBooker;
        this.reservationRequest.passengers[0].customerId = item;
      } else {
        this.reservationRequest.passengers[0].companyId = null;
        this.reservationRequest.passengers[0].customerId = null;
      }
    },
    printMoney(value) {
      return this.moneyFormat
        ? numeral(value).format(this.moneyFormat.decimalFormat)
        : value;
    },
    refresh() {
      const queryParam = {};
      switch (this.searchParameter.serviceType.toLocaleLowerCase()) {
        case "airporttransfer":
          // pick-up
          queryParam.plt = this.searchParameter.pickUpLocation.latitude;
          queryParam.plg = this.searchParameter.pickUpLocation.longitude;
          queryParam.pcd = this.searchParameter.pickUpLocation.code;
          queryParam.pad = this.searchParameter.pickUpLocation.address;
          queryParam.pnm = this.searchParameter.pickUpLocation.name;
          queryParam.pcn = this.searchParameter.pickUpLocation.country;

          // drop-off
          queryParam.dlt = this.searchParameter.dropOffLocation.latitude;
          queryParam.dlg = this.searchParameter.dropOffLocation.longitude;
          queryParam.dcd = this.searchParameter.dropOffLocation.code;
          queryParam.dad = this.searchParameter.dropOffLocation.address;
          queryParam.dnm = this.searchParameter.dropOffLocation.name;
          queryParam.dcn = this.searchParameter.dropOffLocation.country;

          // start rent
          queryParam.ptm =
            this.searchParameter.pickUpDate.year +
            "." +
            this.searchParameter.pickUpDate.month +
            "." +
            this.searchParameter.pickUpDate.day +
            "-" +
            this.searchParameter.pickUpDate.hour +
            "." +
            this.searchParameter.pickUpDate.minute;

          // service type
          queryParam.svc = "airporttransfer";
          break;
        case "rental":
          // pick-up location (coordinate & address)
          queryParam.plt = this.searchParameter.pickUpLocation.latitude;
          queryParam.plg = this.searchParameter.pickUpLocation.longitude;
          queryParam.pad = this.searchParameter.pickUpLocation.address;
          queryParam.pnm = this.searchParameter.pickUpLocation.name;
          queryParam.pcn = this.searchParameter.pickUpLocation.country;

          // start rent
          queryParam.str =
            this.searchParameter.pickUpDate.year +
            "." +
            this.searchParameter.pickUpDate.month +
            "." +
            this.searchParameter.pickUpDate.day +
            "-" +
            this.searchParameter.pickUpDate.hour +
            "." +
            this.searchParameter.pickUpDate.minute;

          // end rent
          queryParam.enr =
            this.searchParameter.dropOffDate.year +
            "." +
            this.searchParameter.dropOffDate.month +
            "." +
            this.searchParameter.dropOffDate.day +
            "-" +
            this.searchParameter.dropOffDate.hour +
            "." +
            this.searchParameter.dropOffDate.minute;

          // with driver / self drive
          queryParam.slf = this.isSelfDrive;

          // service type
          queryParam.svc = "rental";
          break;
      }
      queryParam.mode = this.searchParameter.mode;
      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);
      this.$router.push({ path: "/availability/instant", query: queryParam });
    },
    copyBooker() {
      if (this.isPassengerSameAsBooker) {
        if (
          this.reservationRequest.booker.companyId !=
          this.reservationRequest.passengers[0].companyId
        ) {
          this.getPassengersByCompanyId(
            this.reservationRequest.booker.companyId
          );
        }
        this.$nextTick(() => {
          this.reservationRequest.passengers[0].companyId =
            this.reservationRequest.booker.companyId;
          this.reservationRequest.passengers[0].customerId =
            this.reservationRequest.booker.customerId;
          this.reservationRequest.passengers[0].title =
            this.reservationRequest.booker.freetext.title;
          this.reservationRequest.passengers[0].fullName =
            this.reservationRequest.booker.freetext.fullName;
          this.reservationRequest.passengers[0].phoneCode =
            this.reservationRequest.booker.freetext.phoneCode;
          this.reservationRequest.passengers[0].phoneNumber =
            this.reservationRequest.booker.freetext.phoneNumber;
          this.reservationRequest.passengers[0].email =
            this.reservationRequest.booker.freetext.email;
        });
      } else {
        if (this.useCompanySelection && this.useCustomerSelection) {
          this.reservationRequest.passengers[0].companyId = null;
          this.reservationRequest.passengers[0].customerId = null;
        } else {
          this.reservationRequest.passengers[0].companyId =
            this.$helper.emptyGuid();
          this.reservationRequest.passengers[0].customerId =
            this.$helper.emptyGuid();
        }

        this.reservationRequest.passengers[0].title = null;
        this.reservationRequest.passengers[0].fullName = null;
        this.reservationRequest.passengers[0].phoneCode = null;
        this.reservationRequest.passengers[0].phoneNumber = null;
        this.reservationRequest.passengers[0].email = null;
      }
    },
    constructPayload() {
      const payload = {
        serviceType: this.searchParameter.serviceType,
        correlationId: this.reservationRequest.correlationId,
        selectorId: this.reservationRequest.selectorId,
        departureAirline: this.isAirportTransfer
          ? this.reservationRequest.departureAirline.toUpperCase()
          : null,
        departureFlightNumber: this.reservationRequest.departureFlightNumber,
        notes: this.reservationRequest.notes,
        booker: {
          companyId: this.reservationRequest.booker.companyId,
          customerId: this.reservationRequest.booker.customerId,
        },
        passengers: [
          {
            companyId: this.reservationRequest.passengers[0].companyId,
            customerId: this.reservationRequest.passengers[0].customerId,
          },
        ],
        ancillaries: [],
      };

      if (this.isUseFreetext(payload.booker.customerId)) {
        payload.booker.freetext = this.reservationRequest.booker.freetext;
      }

      if (this.isUseFreetext(payload.passengers[0].customerId)) {
        payload.passengers[0].freetext = {
          title: this.reservationRequest.passengers[0].title,
          fullName: this.reservationRequest.passengers[0].fullName,
          email: this.reservationRequest.passengers[0].email,
          phoneCode: this.reservationRequest.passengers[0].phoneCode,
          phoneNumber: this.reservationRequest.passengers[0].phoneNumber,
        };
      }

      const overrideBookerWithFreetext =
        payload.booker.companyId === this.$helper.emptyGuid() &&
        payload.booker.customerId === this.$helper.emptyGuid();
      const overridePaxWithFreetext =
        payload.passengers[0].companyId === this.$helper.emptyGuid() &&
        payload.passengers[0].customerId === this.$helper.emptyGuid();

      if (overrideBookerWithFreetext) {
        payload.booker = {
          freetext: this.reservationRequest.booker.freetext,
        };
      }

      if (overridePaxWithFreetext) {
        payload.passengers[0] = {
          freetext: {
            title: this.reservationRequest.passengers[0].title,
            fullName: this.reservationRequest.passengers[0].fullName,
            email: this.reservationRequest.passengers[0].email,
            phoneCode: this.reservationRequest.passengers[0].phoneCode,
            phoneNumber: this.reservationRequest.passengers[0].phoneNumber,
          },
        };
      }

      if (this.selectedAncillaries && this.selectedAncillaries.length > 0) {
        payload.ancillaries = this.selectedAncillaries.map((ancillary) => {
          return {
            id: ancillary.id,
            quantity: parseInt(ancillary.quantity),
          };
        });
      }

      return payload;
    },
    async getPhoneCodes() {
      this.phoneCodes = await countryPhoneService.getAll();
      for (let i = 0; i < this.phoneCodes.length; i++) {
        const item = this.phoneCodes[i];
        item.label = `${item.iata} (+${item.dial})`;
        item.icon = `iti-flag ${item.iata.toLowerCase()}`;
      }
    },
    async getBookingInfo() {
      try {
        this.isLoading = true;

        const response = await instantAvailabilityService.loadBookingForm({
          correlationId: this.$route.params.id,
        });

        this.reservationRequest.correlationId = this.$route.params.id;
        this.reservationRequest.serviceType = response.queryCache.serviceType;
        this.reservationRequest.selectorId =
          response.queryCache.data.selectorId;
        this.reservationRequest.selfDriveRateType =
          response.queryCache.selfDriveRateType;
        this.moneyFormat = response.queryCache.moneyFormat;
        this.searchParameter = {
          dropOffDate: response.queryCache.dropOffDate,
          dropOffLocation: response.queryCache.dropOffLocation,
          serviceType: response.queryCache.serviceType,
          pickUpDate: response.queryCache.pickUpDate,
          pickUpLocation: response.queryCache.pickUpLocation,
          mode: response.queryCache.mode,
        };
        this.isSelfDrive = response.queryCache.isSelfDrive;
        this.rentDays = response.queryCache.rentDays;
        this.vehicle = response.queryCache.data;
        this.ancillaries = response.queryCache.data.ancillaries;
        this.airlines = response.airlines;
        this.companies = response.companies;

        if (this.ancillaries && this.ancillaries.length > 0) {
          for (let i = 0; i < this.ancillaries.length; i++) {
            const ancillary = this.ancillaries[i];
            this.reservationRequest.ancillaries.push({ quantity: 0 });
          }
        }

        for (let i = 0; i < this.companies.length; i++) {
          const company = this.companies[i];
          for (let j = 0; j < company.customers.length; j++) {
            const customer = company.customers[j];
            customer.label = `${customer.title}. ${customer.fullName}`;
          }
        }
      } catch (error) {
        this.$helper.redirectToServerError(this);
        return;
      } finally {
        this.isLoading = false;
      }
    },
    async validateDoubleBook() {
      this.isSubmitted = true;
      this.$v.reservationRequest.$touch();
      if (this.$v.reservationRequest.$error) {
        this.$nextTick(() => this.$helper.focusToFieldError());
        return;
      }
      try {
        this.isLoading = true;

        // const request = {
        //   mainPassenger: this.reservationRequest.passengers[0],
        //   correlationId: this.reservationRequest.correlationId,
        // };
        // const response = await inquiryReservationService.validateDoubleBook(request);
        // if (response && response.isExist) {
        //   $("#DoubleBookConfirmation").modal({ backdrop: "static", keyboard: false });
        //   return;
        // }
        await this.bookNow();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async bookNow() {
      try {
        this.isLoading = true;

        const payload = this.constructPayload();

        const reservationNumber = await instantReservationService.create(
          payload
        );

        // book success, then redirects to reservation page
        this.$router.push({
          path: `/reservation/instant/${reservationNumber}`,
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reservation/instant/ReservationForm.vue